import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Storage } from '@ionic/storage-angular';
import { EventType } from '../interfaces/event-type';

@Injectable({
  providedIn: 'root'
})
export class EventtypeService implements OnInit {
  eventtypeDataSubject = new Subject();
  eventtypeNewDataSubject = new Subject();
  eventtypeSave = new Subject();

  company: any;
  constructor(
    private http: HttpClient,
    private storage: Storage
  ) { }

  async ngOnInit() {

  }
  async ionViewWillEnter() {
    if (!this.company._id)
      this.company = await this.storage.get(environment.storage.company);
  }

  getAllEventtypes(companyId: string): Observable<any> {
    return this.http.get(`${environment.url}/bucket/${environment.buckets.eventType}/data?filter={"company":"${companyId}"}&relation=true`)
  }

  saveEvent(eventType: EventType): Observable<any> {
    if (eventType._id) {
      const flated = this.flatEventtype(eventType);
      return this.updateEventtype(flated);
    } else {
      console.log('COM_KEY', eventType.company);
      return this.addEventtype(eventType);
    }
  }

  private updateEventtype(eventType: any): Observable<any> {// FUNKTIONIERT
    return this.http.put(`${environment.url}/bucket/${environment.buckets.eventType}/data/${eventType._id}`, eventType);
  }

  private addEventtype(eventType): Observable<any> {// FUNKTIOINIERT
    return this.http.post(`${environment.url}/bucket/${environment.buckets.eventType}/data/`, eventType);
  }

  deleteEventtype(id: string) { //FUNKTIONIERT
    return this.http.delete(`${environment.url}/bucket/${environment.buckets.eventType}/data/${id}`);
  }

  getEventtypeById(id: string) {
    return this.http.get(`${environment.url}/bucket/${environment.buckets.eventType}/data/${id}`)
  }

  // TODO: Flaten von Objekt
  flatEventtype(eventtype) {
    if (typeof eventtype.company !== "string")
      eventtype.company = eventtype.company._id;//flaten funktioniert
    // if (typeof eventtype.service_group !== "string")
    //   eventtype.service_group = eventtype.service_group._id;
    // if (typeof eventtype.target !== "string")
    //   eventtype.target = eventtype.target._id;
    console.log('flatEventtype:', eventtype.company);
    return eventtype;
  }
}

